const includesField = (field, fieldsArray) => {
  if (!fieldsArray || !fieldsArray.length) {
    return false;
  }
  return fieldsArray.includes(field);
};

export const isFieldRequiredEntity = (field, requiredFields) => {
  if (!requiredFields || !requiredFields.campos) {
    return false;
  }
  return includesField(field, requiredFields.campos);
};

export const isFieldRequiredEntityItens = (field, requiredFields) => {
  if (!requiredFields || !requiredFields.camposItens) {
    return false;
  }
  return includesField(field, requiredFields.camposItens);
};

export const isFieldReadonlyEntity = (field, readOnlyFields) => {
  if (!readOnlyFields || !readOnlyFields.campos) {
    return false;
  }
  return includesField(field, readOnlyFields.campos);
};

export const isFieldReadonlyEntityItens = (field, readOnlyFields) => {
  if (!readOnlyFields || !readOnlyFields.camposItens) {
    return false;
  }
  return includesField(field, readOnlyFields.camposItens);
};
